import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FieldInput, FieldLabel, FieldPrefix, FieldRow, ModalBackdrop, ModalBody, ModalCard, ModalClose, ModalHead, ModalTitle, SaveBtn, } from "./profile.style";
import { SOCIAL_PLATFORM_META } from "./profile.utils";
var EditSocialLinksModal = function (_a) {
    var open = _a.open, links = _a.links, _b = _a.saving, saving = _b === void 0 ? false : _b, onClose = _a.onClose, onSave = _a.onSave;
    var _c = useState({}), values = _c[0], setValues = _c[1];
    useEffect(function () {
        if (open) {
            var initial_1 = {};
            links.forEach(function (l) {
                initial_1[l.platform] = l.handle || "";
            });
            setValues(initial_1);
        }
    }, [open, links]);
    if (!open)
        return null;
    return (_jsx(ModalBackdrop, { onClick: onClose, children: _jsxs(ModalCard, { onClick: function (e) { return e.stopPropagation(); }, children: [_jsxs(ModalHead, { children: [_jsx(ModalTitle, { children: "\uD83D\uDD17 Social Links" }), _jsx(ModalClose, { type: "button", onClick: onClose, children: "\u2715" })] }), _jsxs(ModalBody, { children: [links.map(function (link) {
                            var meta = SOCIAL_PLATFORM_META[link.platform];
                            return (_jsxs("div", { children: [_jsxs(FieldLabel, { children: [meta === null || meta === void 0 ? void 0 : meta.icon, " ", link.label] }), _jsxs(FieldRow, { children: [_jsx(FieldPrefix, { children: meta === null || meta === void 0 ? void 0 : meta.prefix }), _jsx(FieldInput, { value: values[link.platform] || "", placeholder: "your username", onChange: function (e) {
                                                    return setValues(function (prev) {
                                                        var _a;
                                                        return (__assign(__assign({}, prev), (_a = {}, _a[link.platform] = e.target.value, _a)));
                                                    });
                                                } })] })] }, link.platform));
                        }), _jsx(SaveBtn, { type: "button", disabled: saving, onClick: function () { return onSave(values); }, children: saving ? "Saving…" : "Save Links" })] })] }) }));
};
export default EditSocialLinksModal;
